export enum ProjectAssessmentType {
  TASKS = 'PROBLEMS',
  INTERVIEW_ONLY = 'INTERVIEW_ONLY',
}

export enum ProjectTestTaskTime {
  D_1 = 'D_1',
  D_2 = 'D_2',
  D_3 = 'D_3',
  D_4 = 'D_4',
  D_5 = 'D_5',
}
